import { render } from "./newsPage.vue?vue&type=template&id=2a1a29ea"
import script from "./newsPage.vue?vue&type=script&lang=js"
export * from "./newsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__